import { IBusLocation } from "@/domain/entities/lineInfo";
import { AllocStatusCode } from "@/types";
import { ref } from "vue";

/** 현재 존재하는 모든 버스의 운행 상태가 '종료'인지 관리하는 Composable */
export const useHasAllBusesEndedDriving = () => {
  const hasAllBusesEndedDriving = ref(false);

  const resetHasAllBusesEndedDriving = () => {
    hasAllBusesEndedDriving.value = false;
  };

  const updateHasAllBusesEndedDriving = (locations: IBusLocation[]) => {
    if (!locations.length) {
      hasAllBusesEndedDriving.value = false;
      return;
    }

    hasAllBusesEndedDriving.value = locations.every(
      (location) => location.allocStatusCode === AllocStatusCode.DRIVEN
    );
  };

  return {
    hasAllBusesEndedDriving,
    resetHasAllBusesEndedDriving,
    updateHasAllBusesEndedDriving,
  };
};
